exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".children-wrapper{background:#eee;left:0;top:0;right:0;min-height:100%;overflow-x:hidden;overflow-y:auto;position:absolute;z-index:1000;-webkit-overflow-scrolling:touch}", ""]);

// exports
